module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('chart-layout', {
    attrs: {
      "title": _vm.title,
      "yAxis": _vm.yAxis,
      "xAxis": _vm.xAxis
    }
  }, [_c('bar-graph', {
    attrs: {
      "chart-data": _vm.data,
      "chart-id": _vm.chartIdOverride,
      "type": _vm.type
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3c6f675a","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/appComponents/graphs/AgeDistributionGraph.vue
// module id = 2053
// module chunks = 0